/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetchartLayout,
  FleetchartLayoutInput,
  FleetchartLayoutsList,
  SchemaValidationErrorResponse,
  StandardError,
  SuccessResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Fleetchart Layouts
 */
export const fleetchartLayouts = (

 signal?: AbortSignal
) => {


      return axiosClient<FleetchartLayoutsList>(
      {url: `/hangar/fleetchart-layouts`, method: 'GET', signal
    },
      );
    }




export const getFleetchartLayoutsQueryKey = () => {
    return [
    'hangar','fleetchart-layouts'
    ] as const;
    }


export const getFleetchartLayoutsQueryOptions = <TData = Awaited<ReturnType<typeof fleetchartLayouts>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetchartLayouts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetchartLayoutsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetchartLayouts>>> = ({ signal }) => fleetchartLayouts(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetchartLayouts>>, TError, TData>
}

export type FleetchartLayoutsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetchartLayouts>>>
export type FleetchartLayoutsQueryError = ErrorType<StandardError>


/**
 * @summary Fleetchart Layouts
 */

export function useFleetchartLayouts<TData = Awaited<ReturnType<typeof fleetchartLayouts>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetchartLayouts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetchartLayoutsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Fleetchart Layout
 */
export const createFleetchartLayout = (
    fleetchartLayoutInput: MaybeRefOrGetter<FleetchartLayoutInput>,
 signal?: AbortSignal
) => {
      fleetchartLayoutInput = toValue(fleetchartLayoutInput);

      return axiosClient<FleetchartLayout>(
      {url: `/hangar/fleetchart-layouts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetchartLayoutInput, signal
    },
      );
    }




export const getCreateFleetchartLayoutMutationKey = () => ['createFleetchartLayout'] as const;

export const getCreateFleetchartLayoutMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetchartLayout>>, TError,CreateFleetchartLayoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetchartLayout>>, TError,CreateFleetchartLayoutMutationVariables, TContext> => {

const mutationKey = getCreateFleetchartLayoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetchartLayout>>, CreateFleetchartLayoutMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createFleetchartLayout(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetchartLayoutMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetchartLayout>>>
    export type CreateFleetchartLayoutMutationBody = FleetchartLayoutInput
    export type CreateFleetchartLayoutMutationError = ErrorType<ValidationError | StandardError>
    export type CreateFleetchartLayoutMutationVariables = {data: FleetchartLayoutInput}

    /**
 * @summary Create Fleetchart Layout
 */
export const useCreateFleetchartLayout = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetchartLayout>>, TError,CreateFleetchartLayoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetchartLayout>>,
        TError,
        CreateFleetchartLayoutMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetchartLayoutMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleetchart Layout
 */
export const fleetchartLayout = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<FleetchartLayout>(
      {url: `/hangar/fleetchart-layouts/${id}`, method: 'GET', signal
    },
      );
    }




export const getFleetchartLayoutQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'hangar','fleetchart-layouts',id
    ] as const;
    }


export const getFleetchartLayoutQueryOptions = <TData = Awaited<ReturnType<typeof fleetchartLayout>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetchartLayout>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetchartLayoutQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetchartLayout>>> = ({ signal }) => fleetchartLayout(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetchartLayout>>, TError, TData>
}

export type FleetchartLayoutQueryResult = NonNullable<Awaited<ReturnType<typeof fleetchartLayout>>>
export type FleetchartLayoutQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleetchart Layout
 */

export function useFleetchartLayout<TData = Awaited<ReturnType<typeof fleetchartLayout>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetchartLayout>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetchartLayoutQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Fleetchart Layout
 */
export const updateFleetchartLayout = (
    id: MaybeRefOrGetter<string>,
    fleetchartLayoutInput: MaybeRefOrGetter<FleetchartLayoutInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
fleetchartLayoutInput = toValue(fleetchartLayoutInput);

      return axiosClient<FleetchartLayout>(
      {url: `/hangar/fleetchart-layouts/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetchartLayoutInput, signal
    },
      );
    }




export const getUpdateFleetchartLayoutMutationKey = () => ['updateFleetchartLayout'] as const;

export const getUpdateFleetchartLayoutMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetchartLayout>>, TError,UpdateFleetchartLayoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetchartLayout>>, TError,UpdateFleetchartLayoutMutationVariables, TContext> => {

const mutationKey = getUpdateFleetchartLayoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetchartLayout>>, UpdateFleetchartLayoutMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateFleetchartLayout(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetchartLayoutMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetchartLayout>>>
    export type UpdateFleetchartLayoutMutationBody = FleetchartLayoutInput
    export type UpdateFleetchartLayoutMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateFleetchartLayoutMutationVariables = {id: string;data: FleetchartLayoutInput}

    /**
 * @summary Update Fleetchart Layout
 */
export const useUpdateFleetchartLayout = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetchartLayout>>, TError,UpdateFleetchartLayoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetchartLayout>>,
        TError,
        UpdateFleetchartLayoutMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetchartLayoutMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Fleetchart Layout
 */
export const destroyFleetchartLayout = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<SuccessResponse>(
      {url: `/hangar/fleetchart-layouts/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetchartLayoutMutationKey = () => ['destroyFleetchartLayout'] as const;

export const getDestroyFleetchartLayoutMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetchartLayout>>, TError,DestroyFleetchartLayoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetchartLayout>>, TError,DestroyFleetchartLayoutMutationVariables, TContext> => {

const mutationKey = getDestroyFleetchartLayoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetchartLayout>>, DestroyFleetchartLayoutMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyFleetchartLayout(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetchartLayoutMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetchartLayout>>>

    export type DestroyFleetchartLayoutMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetchartLayoutMutationVariables = {id: string}

    /**
 * @summary Delete Fleetchart Layout
 */
export const useDestroyFleetchartLayout = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetchartLayout>>, TError,DestroyFleetchartLayoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetchartLayout>>,
        TError,
        DestroyFleetchartLayoutMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetchartLayoutMutationOptions(options), queryClient);
    }
    /**
 * @summary Share Fleetchart Layout
 */
export const shareFleetchartLayout = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<FleetchartLayout>(
      {url: `/hangar/fleetchart-layouts/${id}/share`, method: 'PUT', signal
    },
      );
    }




export const getShareFleetchartLayoutMutationKey = () => ['shareFleetchartLayout'] as const;

export const getShareFleetchartLayoutMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareFleetchartLayout>>, TError,ShareFleetchartLayoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof shareFleetchartLayout>>, TError,ShareFleetchartLayoutMutationVariables, TContext> => {

const mutationKey = getShareFleetchartLayoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shareFleetchartLayout>>, ShareFleetchartLayoutMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  shareFleetchartLayout(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ShareFleetchartLayoutMutationResult = NonNullable<Awaited<ReturnType<typeof shareFleetchartLayout>>>

    export type ShareFleetchartLayoutMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ShareFleetchartLayoutMutationVariables = {id: string}

    /**
 * @summary Share Fleetchart Layout
 */
export const useShareFleetchartLayout = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareFleetchartLayout>>, TError,ShareFleetchartLayoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof shareFleetchartLayout>>,
        TError,
        ShareFleetchartLayoutMutationVariables,
        TContext
      > => {
      return useMutation(getShareFleetchartLayoutMutationOptions(options), queryClient);
    }
    /**
 * @summary Unshare Fleetchart Layout
 */
export const unshareFleetchartLayout = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<FleetchartLayout>(
      {url: `/hangar/fleetchart-layouts/${id}/share`, method: 'DELETE', signal
    },
      );
    }




export const getUnshareFleetchartLayoutMutationKey = () => ['unshareFleetchartLayout'] as const;

export const getUnshareFleetchartLayoutMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unshareFleetchartLayout>>, TError,UnshareFleetchartLayoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unshareFleetchartLayout>>, TError,UnshareFleetchartLayoutMutationVariables, TContext> => {

const mutationKey = getUnshareFleetchartLayoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unshareFleetchartLayout>>, UnshareFleetchartLayoutMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  unshareFleetchartLayout(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnshareFleetchartLayoutMutationResult = NonNullable<Awaited<ReturnType<typeof unshareFleetchartLayout>>>

    export type UnshareFleetchartLayoutMutationError = ErrorType<SchemaValidationErrorResponse>
    export type UnshareFleetchartLayoutMutationVariables = {id: string}

    /**
 * @summary Unshare Fleetchart Layout
 */
export const useUnshareFleetchartLayout = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unshareFleetchartLayout>>, TError,UnshareFleetchartLayoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unshareFleetchartLayout>>,
        TError,
        UnshareFleetchartLayoutMutationVariables,
        TContext
      > => {
      return useMutation(getUnshareFleetchartLayoutMutationOptions(options), queryClient);
    }
